export const APPLY_ADMISSION_REQUEST = "APPLY_ADMISSION_REQUEST";
export const APPLY_ADMISSION_SUCCESS = "APPLY_ADMISSION_SUCCESS";
export const APPLY_ADMISSION_FAIL = "APPLY_ADMISSION_FAIL";

export const GET_ALL_ADMISSIONS_REQUEST = "GET_ALL_ADMISSIONS_REQUEST";
export const GET_ALL_ADMISSIONS_SUCCESS = "GET_ALL_ADMISSIONS_SUCCESS";
export const GET_ALL_ADMISSIONS_FAIL = "GET_ALL_ADMISSIONS_FAIL";

export const UPDATE_ADMISSION_STATUS_REQUEST = "UPDATE_ADMISSION_STATUS_REQUEST";
export const UPDATE_ADMISSION_STATUS_SUCCESS = "UPDATE_ADMISSION_STATUS_SUCCESS";
export const UPDATE_ADMISSION_STATUS_FAIL = "UPDATE_ADMISSION_STATUS_FAIL";

export const UPDATE_ADMISSION_DETAILS_REQUEST = "UPDATE_ADMISSION_DETAILS_REQUEST";
export const UPDATE_ADMISSION_DETAILS_SUCCESS = "UPDATE_ADMISSION_DETAILS_SUCCESS";
export const UPDATE_ADMISSION_DETAILS_FAIL = "UPDATE_ADMISSION_DETAILS_FAIL";

export const DELETE_ADMISSION_REQUEST = "DELETE_ADMISSION_REQUEST";
export const DELETE_ADMISSION_SUCCESS = "DELETE_ADMISSION_SUCCESS";
export const DELETE_ADMISSION_FAIL = "DELETE_ADMISSION_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 
